module.exports = __webpack_public_path__ + "static/img/messages.5b053cd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/illustrations/messages.svg
// module id = +F2l
// module chunks = 0